import { gql } from "@/gql";

export const GET_SERVICE_TEMPLATES = gql(`
  query GetServiceTemplates($franchiseId: String!) {
    getServiceTemplates(franchiseId: $franchiseId) {
      id
      name
      scope
      sortOrder
      isActive
      storefrontDisplayMode
      groups {
        id
        name
        selectionType
        minSelections
        maxSelections
        sortOrder
        options {
          id
          optionName
          durationModifier
          isDefault
          sortOrder
        }
      }
    }
  }
`);

export const GET_SERVICE_TEMPLATE = gql(`
  query GetServiceTemplate($templateId: String!) {
    getServiceTemplate(templateId: $templateId) {
      id
      name
      scope
      sortOrder
      isActive
      storefrontDisplayMode
      groups {
        id
        name
        selectionType
        minSelections
        maxSelections
        sortOrder
        options {
          id
          optionName
          durationModifier
          isDefault
          sortOrder
        }
      }
    }
  }
`);

export const APPLY_SERVICE_TEMPLATE_TO_SERVICE = gql(`
  mutation ApplyServiceTemplateToService(
    $serviceId: String!
    $templateId: String!
    $franchiseId: String!
    $language: String!
  ) {
    applyServiceTemplateToService(
      serviceId: $serviceId
      templateId: $templateId
      franchiseId: $franchiseId
      language: $language
    ) {
      id
      name
      selectionType
      minSelections
      maxSelections
      sortOrder
      options {
        id
        optionName
        priceModifier
        durationModifier
        isDefault
        sortOrder
      }
    }
  }
`);

export const CREATE_SERVICE_TEMPLATE = gql(`
  mutation CreateServiceTemplate($franchiseId: String!, $input: CreateServiceTemplateInput!) {
    createServiceTemplate(franchiseId: $franchiseId, input: $input) {
      id
      name
      scope
      sortOrder
      storefrontDisplayMode
      groups {
        id
        name
        selectionType
        minSelections
        maxSelections
        sortOrder
        options {
          id
          optionName
          durationModifier
          isDefault
          sortOrder
        }
      }
    }
  }
`);

export const DELETE_SERVICE_TEMPLATE = gql(`
  mutation DeleteServiceTemplate($templateId: String!) {
    deleteServiceTemplate(templateId: $templateId)
  }
`);
